import React, { useEffect, useRef, useState } from "react";
import Header from "../components/Header";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";
import "../styles/Trans.scss";
import { useModal } from "../components/ModalContext";
const TransXtLogo = `${process.env.REACT_APP_S3_URL}transxtLogo.svg`;
const QRCode = `${process.env.REACT_APP_S3_URL}QR Code.svg`;
const PaymentLinks = `${process.env.REACT_APP_S3_URL}Payment Links.svg`;
const CollectBill = `${process.env.REACT_APP_S3_URL}Collect bill via BBPS.svg`;
const UPIAutopay = `${process.env.REACT_APP_S3_URL}UPI autopay.svg`;
const IMPSPayouts = `${process.env.REACT_APP_S3_URL}IMPS payouts.svg`;
const UPIPayouts = `${process.env.REACT_APP_S3_URL}UPI payouts.svg`;
const AccVerification = `${process.env.REACT_APP_S3_URL}Acc No. Verification.svg`;
const PanBankAccVerification = `${process.env.REACT_APP_S3_URL}PanBankAccVerification.svg`;
const MobileBankAccVerification = `${process.env.REACT_APP_S3_URL}MobileBankAccVerification.svg`
const CardHoverIcon = `${process.env.REACT_APP_S3_URL}CardHoverIcon.svg`;
const LockHoverIcon = `${process.env.REACT_APP_S3_URL}LockHoverIcon.svg`;
const QRHoverIcon = `${process.env.REACT_APP_S3_URL}QRHoverIcon.svg`;
const ShieldHoverIcon = `${process.env.REACT_APP_S3_URL}ShieldHoverIcon.svg`;
const WalletHoverIcon = `${process.env.REACT_APP_S3_URL}WalletHoverIcon.svg`;
const RupeeHoverIcon = `${process.env.REACT_APP_S3_URL}RupeeHoverIcon.svg`;
const Arrow = `${process.env.REACT_APP_S3_URL}RIghtArrowBgWhite.svg`;
const Mouse = `${process.env.REACT_APP_S3_URL}Computer%20Mouse.svg`;
const MouseDir = `${process.env.REACT_APP_S3_URL}mouseDirection.png`;
const RIghtArrowBgWhite = `${process.env.REACT_APP_S3_URL}RIghtArrowBgWhite.svg`;

type GridCell = {
  index: number;
  row: number;
  col: number;
  columns: number;
  rows: number;
};

const TransXT: React.FC = () => {
  const { openModal } = useModal();
  // State to track the selected service
  const [selectedService, setSelectedService] =
    useState<string>("accept-payments");

  const [gridCells, setGridCells] = useState<GridCell[]>([]); // Update state type to hold GridCell objects
  const [hoveredCount, setHoveredCount] = useState(0); // Count of hovered cells
  const [cellsWithIcons, setCellsWithIcons] = useState<
    { index: number; icon: string }[]
  >([]); // Cells that have icons
  const containerRef = useRef<HTMLDivElement>(null);
  const [selectIcon, setSelectIcon] = useState(0);

  // Paths to your icons
  const icons = [
    CardHoverIcon,
    LockHoverIcon,
    QRHoverIcon,
    ShieldHoverIcon,
    WalletHoverIcon,
    RupeeHoverIcon,
  ];

  const calculateVisibleCells = () => {
    if (containerRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      const containerHeight = containerRef.current.offsetHeight;

      // Define the size of each cell (assuming each grid cell is 70px)
      const cellSize = 70;

      // Calculate how many rows and columns fit into the container
      const columns = Math.floor(containerWidth / cellSize);
      const rows = Math.floor(containerHeight / cellSize);

      // Generate the grid based on visible rows and columns
      const newGridCells = Array.from(
        { length: rows * columns },
        (_, index) => {
          const row = Math.floor(index / columns);
          const col = index % columns;
          const opacity = calculateOpacity(row, col, rows, columns);
          return {
            index,
            row,
            col,
            columns,
            rows,
            opacity,
          };
        }
      );

      setGridCells(newGridCells); // Update the state with the visible grid cells
    }
  };

  useEffect(() => {
    // Calculate grid cells on component mount and window resize
    calculateVisibleCells();
    window.addEventListener("resize", calculateVisibleCells);

    return () => {
      window.removeEventListener("resize", calculateVisibleCells);
    };
  }, []);

  const calculateOpacity = (
    row: number,
    col: number,
    rows: number,
    columns: number
  ) => {
    // Reference point is the bottom-left corner [rows-1, 0] (e.g., [9,0] in the 10x22 example)
    const bottomLeftRow = rows - 1;
    const bottomLeftCol = 0;

    // Max possible Manhattan distance from the bottom-left corner to the farthest corner (top-right)
    const maxDistance = bottomLeftRow + (columns - 1); // This is the longest path (Manhattan distance)

    // Calculate Manhattan distance from the current cell to the bottom-left corner
    const distance =
      Math.abs(row - bottomLeftRow) + Math.abs(col - bottomLeftCol);

    // Normalize the opacity: when distance is 0, opacity = 1.0; when distance is maxDistance, opacity = 0.1
    const normalizedOpacity = 1 - (distance / maxDistance) * 0.9;

    // Ensure the opacity is at least 0.1
    return Math.max(0.1, normalizedOpacity);
  };

  const handleHover = (index: number) => {
    // Only count if the cell has not been assigned an icon
    if (!cellsWithIcons.some((cell) => cell.index === index)) {
      setHoveredCount((prevCount) => prevCount + 1);
    }

    // If the hovered count reaches 6, assign the next icon in sequence
    if (hoveredCount + 1 === 6) {
      const nextIcon = icons[selectIcon % icons.length]; // Cycle through icons
      setSelectIcon((prev) => prev + 1);
      setCellsWithIcons((prev) => [...prev, { index, icon: nextIcon }]);
      setHoveredCount(0); // Reset the count after every 5th hover

      // Set a timeout to remove the icon after 3 seconds
      setTimeout(() => {
        setCellsWithIcons((prev) =>
          prev.filter((cell) => cell.index !== index)
        );
      }, 2000);
    }
  };

  const paymentsCardsData = [
    {
      title: "QR Code",
      description:
        "Generate Static & Dynamic QR Codes & easily collect payments from your customers \n \n Whether you're an offline merchant or corporate looking to generate QR codes for accepting payments, get started with our APIs on our TransXT platform",
      tags: [
        { id: 1, name: "QR Payment" },
        { id: 2, name: "Static QR" },
        { id: 3, name: "Dynamic QR" },
        { id: 4, name: "Merchant Payments" },
      ],
      imageSrc: QRCode,
    },
    {
      title: "UPI Autopay",
      description:
        "Accept recurring payments from your customers via APIs on our platform via UPI Auto-Pay mandates \n \n Set frequency as Daily, Weekly or Monthly & automate recurring payment collections for your customers ",
      tags: [
        { id: 1, name: "Recurring Payments" },
        { id: 2, name: "Loan Repayments" },
        { id: 3, name: "Subscriptions" },
        { id: 4, name: "Insurance Premium Collections" },
      ],
      imageSrc: UPIAutopay,
      reverse: true,
    },
    {
      title: "Payment Links",
      description:
        "Payment Links simplifies payments through Unified Payments Interface (UPI) with TransXT for creating and sharing personalized payment links vis SMS and Email \n \n You can effortlessly generate unique links for each transaction, allowing recipients to click and complete payments securely through their preferred UPI app ",
      tags: [
        { id: 1, name: "Collect Payments" },
        { id: 2, name: "Preferred UPI app" },
        { id: 3, name: "SMS/Whatsapp Links" },
        { id: 4, name: "Bulk Payment links" },
      ],
      imageSrc: PaymentLinks,
      reverse: true,
    },
    {
      title: "Collect Bill Payments via BBPS",
      description:
        "Onboard your business as a biller on NPCI's BBPS ecosystem & make it easy for customers to pay you via 150+ leading UPI & bank apps \n \n Stop manually accepting payments & automate bill collections via Transxt's BBPS ecosystem",
      tags: [
        { id: 1, name: "Automate Collections" },
        { id: 2, name: "BBPS Onboarding" },
        { id: 3, name: "T+1 Settlement" },
        { id: 4, name: "Flexible Bill Payments" },
      ],
      imageSrc: CollectBill,
      reverse: true,
    },
  ];

  const payoutsCardsData = [
      {
        title: 'UPI Payouts',
        description: 'Onboard your business with our partner banks & start doing payouts to relevant stakeholders via UPI \n \n Do single or bulk payouts to Mobile Number or VPA without having to add Account Details or Beneficiaries',
        tags: [
          { id: 1, name: 'Payout to VPA' },
          { id: 2, name: 'Payout to Mobile No.' },
          { id: 3, name: 'Pay Via UPI' },
          { id: 4, name: 'Flexible Bill Payments' },
        ],
        imageSrc: UPIPayouts,
        reverse: true,
      },
      {
        title: 'IMPS Payouts',
        description: 'For high value transactions, use our IMPS rails for your business to make P2P & P2A payouts to relevant stakeholders \n \n Do single or bulk payout to Account Numbers or Mobile Number/MMID ',
        tags: [
          { id: 1, name: 'P2P Payments' },
          { id: 2, name: 'P2A Payments' },
          { id: 3, name: 'Bulk Payments'},
        ],
        imageSrc: IMPSPayouts,
        reverse: true,
      },
  ];

  const verificationCardsData = [
    {
      title: "A/c No. Verification",
      description:
        "If you’re a financial institution looking to verify your customer’s bank account, use our UPI & IMPS rails for Penny-drop services  \n \n Get high success rates, seamless API integration & rich MIS reports to automate your Bank A/c verification needs  ",
      tags: [{ id: 1, name: "PennyDrop Verification" }],
      imageSrc: AccVerification,
      reverse: true,
    },
    {
      title: "Mobile No. to Bank A/c Verification",
      description:
        "Seamlessly link and verify bank accounts through mobile numbers with our advanced verification API.\n \n Achieve real-time validation, minimize onboarding delays, and get actionable insights with our detailed reporting system.  ",
      tags: [{ id: 1, name: "Mobile to Bank A/c Verification" }],
      imageSrc: MobileBankAccVerification,
      reverse: true,
    },
  ];

  const [cardsData, setCardsData] = useState<any>([]);
  useEffect(() => {
    setCardsData(paymentsCardsData);
  }, []);

  // Function to handle service selection with type annotation for parameter
  const handleSelectService = (service: string) => {
    setSelectedService(service);
    if (service === "accept-payments") {
      setCardsData(paymentsCardsData);
    } else if (service === "make-payouts") {
      setCardsData(payoutsCardsData);
    } else if (service === "verification-services") {
      setCardsData(verificationCardsData);
    }
  };

  const CardComponent = (
    title: any,
    description: any,
    tags: any,
    imageSrc: any,
    reverse = false
  ) => {
    return (
      <div className={`card-container ${reverse ? "reverse" : ""}`}>
        <div className="image-container">
          <img src={imageSrc} alt={title} />
        </div>
        <div className="content-container">
          <h3>{title}</h3>
          <p>{description}</p>
          <div className="tags-container">
            {tags.map((tag: any) => (
              <span key={tag.id} className="tag">
                {tag.name}
              </span>
            ))}
          </div>
        </div>
      </div>
    );
  };
  return (
    <div>
      <div className="main-container-transxt" ref={containerRef}>
        {gridCells.map(({ index, row, col, columns, rows }) => (
          <div
            key={index}
            className={`grid-cell-transxt ${
              cellsWithIcons.some((cell) => cell.index === index)
                ? "show-icon"
                : ""
            }`}
            onMouseEnter={() => handleHover(index)}
            style={
              {
                "--hover-opacity": calculateOpacity(row, col, rows, columns),
              } as React.CSSProperties
            }
          >
            {cellsWithIcons.some((cell) => cell.index === index) && (
              <img
                src={cellsWithIcons.find((cell) => cell.index === index)?.icon}
                alt="icon"
                className="icon-img"
              />
            )}
          </div>
        ))}
        <section className="Hero-Section">
          <div>
            <img src={TransXtLogo} />
          </div>
          <h1 className="hero-title">
            API Banking & Payments Stack For Fintechs & Businesses
          </h1>
          <div style={{ display: "flex", flexDirection: "row", gap: 12 }}>
            {/* <div className="contact-sales-button">
                      <div className="contact-sales-text">Get Started &nbsp;&nbsp;
                      </div>
                      <img className='arrow-icon' src={RIghtArrowBgWhite} alt='' />
                  </div> */}
            <div
              onClick={openModal}
              className="contact-sales-button"
              style={{ backgroundColor: "#FFF" }}
            >
              <div className="contact-sales-text" style={{ color: "#252424" }}>
                Contact Sales &nbsp;&nbsp;
              </div>
            </div>
          </div>
          <div className="scroll-indicator">
            <div>
              <div className="mouse-icon">
                <img src={Mouse} alt="Mouse Icon" />
                <img
                  className="mouse-direction"
                  src={MouseDir}
                  alt="Mouse Direction"
                />
              </div>
            </div>
            <p>Scroll Down</p>
          </div>
        </section>
      </div>
      <section>
        <div className="payment-services-section">
          <div
            className={`service accept-payments ${
              selectedService === "accept-payments" ? "selected" : ""
            }`}
            onClick={() => handleSelectService("accept-payments")}
          >
            Accept Payments
          </div>
          <div
            className={`service make-payouts ${
              selectedService === "make-payouts" ? "selected" : ""
            }`}
            onClick={() => handleSelectService("make-payouts")}
          >
            Make Payouts
          </div>
          <div
            className={`service verification-services ${
              selectedService === "verification-services" ? "selected" : ""
            }`}
            onClick={() => handleSelectService("verification-services")}
          >
            Verification Services
          </div>
        </div>
      </section>
      <div className="payment-services-content">
        {cardsData.map((card: any, index: number) =>
          CardComponent(
            card.title,
            card.description,
            card.tags,
            card.imageSrc,
            index % 2 == 0
          )
        )}
      </div>
      <ContactForm />
      <Footer />
    </div>
  );
};

export default TransXT;
